<script>
  import { onMount } from "svelte";
  import {
    items as storeItems,
    giftCards,
    vouchers,
    clickCards,
    onlinePaymentItemsTotal,
    orderTotal,
    balanceItemsTotal,
  } from "./store";

  export let items = [];
  export let strings = {};
  export let currencySymbol = "";

  $storeItems = items;
</script>

{#if $onlinePaymentItemsTotal > 0}
  <input
    name="order[payment_types][][type]"
    type="hidden"
    value="online"
    autocomplete="off" />
  <input
    name="order[payment_types][][amount]"
    type="hidden"
    value={$onlinePaymentItemsTotal}
    autocomplete="off" />

  <div class="t-form-row__center">
    <h4>
      {strings.order_remaining_amount}: {currencySymbol}{$onlinePaymentItemsTotal}
    </h4>
  </div>
{/if}
